import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import { IInvoiceEntity } from '../../shared';

export class InvoiceService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return this.getMany<IInvoiceEntity>(path, search, 'invoices');
  }
}
